import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";

/**
 * Componente NavProps que renderiza elementos de un megamenú.
 *
 * @param {Object} props - Props del componente.
 * @param {Array} props.list - Lista de elementos para el menú.
 * @returns {JSX.Element} - Renderizado de elementos del menú.
 */
const NavProps = ({ list }) => {
  const pathname = usePathname();

  /**
   * Verifica si un enlace debe considerarse activo.
   * Se compara solo una parte de la URL (los primeros 11 caracteres) para determinar la activación parcial.
   *
   * @param {string} href - Enlace a evaluar.
   * @returns {boolean} - Verdadero si el enlace se considera activo.
   */
  const isActive = (href) =>
    pathname.substring(0, 11) === href.substring(0, 11);

  return (
    <div className="col-lg-3 single-mega-item">
      <ul className="mega-menu-item">
        {list &&
          list.map((navItem, index) => (
            <li key={index}>
              {navItem.heading ? (
                // Si el elemento tiene un "heading", se renderiza como título.
                <h3 className="rbt-short-title">{navItem.heading}</h3>
              ) : (
                // Caso contrario, se renderiza como enlace.
                <Link
                  className={`${navItem.isComing ? "disabled" : ""} ${
                    isActive(navItem.link) ? "active" : ""
                  }`}
                  href={navItem.link}
                >
                  <span>{navItem.text}</span>
                  {navItem.badge && (
                    <div className="rainbow-badge-card badge-sm ml--5">
                      {navItem.badge}
                    </div>
                  )}
                </Link>
              )}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default NavProps;
